import { useState } from "react";
import { useTokenManager } from "./useTokenManager";
import { URLS } from "../config/url";

export const useRegisterDelegate = () => {
  const [loading, setLoading] = useState(false);
  const [success, setSuccess] = useState(false);
  const [error, setError] = useState(null);
  const [message, setMessage] = useState(null);
  const { getValidAccessToken } = useTokenManager();

  // let accessToken = localStorage.getItem("accessToken");

  const registerDelegate = async (formData) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    try {
      const formDataToSend = new FormData();

      // Handle nested fullName object
      formDataToSend.append("fullName[first]", formData.fullName?.first || "");
      formDataToSend.append(
        "fullName[middle]",
        formData.fullName?.middle || ""
      );
      formDataToSend.append("fullName[last]", formData.fullName?.last || "");

      // Append other fields
      Object.keys(formData).forEach((key) => {
        if (key !== "fullName") {
          formDataToSend.append(key, formData[key]);
        }
      });

      const accessToken = await getValidAccessToken();

      const response = await fetch(`${URLS}/api/registerUser`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          Authorization: `Bearer ${accessToken}`,
        },
        body: JSON.stringify(formData), // Send FormData directly, no JSON.stringify
      });

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Registration failed");
      }

      setSuccess(true);
      setMessage(data.message || "Registration successful");
      localStorage.setItem("selectedDelegateId", data.user._id);
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  const updateDelegate = async (formData) => {
    setLoading(true);
    setError(null);
    setSuccess(false);

    const userId = localStorage.getItem("selectedDelegateId");
    if (!userId) {
      throw new Error("No user ID found in localStorage");
    }

    try {
      const accessToken = await getValidAccessToken();

      const formDataToSend = new FormData();

      // Append all fields to FormData
      Object.keys(formData).forEach((key) => {
        if (key === "photo" && formData[key]) {
          formDataToSend.append("photo", formData[key]); 
        } else if (formData[key] !== null && formData[key] !== undefined) {
          formDataToSend.append(key, formData[key]);
        }
      });

      // const accessToken = localStorage.getItem("accessToken");
      if (!accessToken) {
        throw new Error("No access token found");
      }

      const response = await fetch(
        `${URLS}/api/registerUser/update/${userId}`,
        {
          method: "POST", // Matches your route
          headers: {
            Authorization: `Bearer ${accessToken}`,
            // Do NOT set Content-Type here; FormData sets it automatically
          },
          body: formDataToSend,
        }
      );

      const data = await response.json();

      if (!response.ok) {
        throw new Error(data.error || "Update failed");
      }

      setSuccess(true);
      setMessage(data.message || "Update successful");
    } catch (err) {
      setError(err.message);
    } finally {
      setLoading(false);
    }
  };

  return { loading, success, error, message, registerDelegate, updateDelegate };
};
